import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, RouterModule } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../../services/auth.service';
import { UserService } from '../../services/user.service';
import { ToastService } from '../../services/toast.service';
import { User } from '../../models/auth.model';
import { MaterialModule } from '../../shared/material.module';
import { ProfileDialogComponent } from '../profile/profile-dialog/profile-dialog.component';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, RouterModule, MaterialModule],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss'
})
export class LayoutComponent {
  currentUser: User | null = null;

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private toastService: ToastService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.authService.currentUser$.subscribe(user => {
      this.currentUser = user;
    });
  }

  logout(): void {
    this.authService.logout();
    this.toastService.success('Logged Out', 'You have been successfully logged out');
    this.router.navigate(['/login']);
  }

  openProfileDialog(): void {
    if (!this.currentUser) {
      this.toastService.error('Error', 'User information not available');
      return;
    }

    const dialogRef = this.dialog.open(ProfileDialogComponent, {
      width: '800px',
      maxWidth: '95vw',
      disableClose: true,
      data: { user: this.currentUser }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Refresh user data if profile was updated
        this.userService.getProfile().subscribe({
          next: (updatedUser) => {
            this.authService.updateCurrentUser(updatedUser);
          },
          error: (error) => {
            console.error('Error refreshing user data:', error);
          }
        });
      }
    });
  }

  getPageTitle(): string {
    const url = this.router.url;
    if (url.includes('/tenants')) return 'Tenant Management';
    if (url.includes('/modules')) return 'Module Management';
    if (url.includes('/assignments')) return 'Module Assignments';
    return 'Dashboard';
  }

  getUserInitials(): string {
    if (!this.currentUser) return '?';
    const firstName = this.currentUser.firstName || '';
    const lastName = this.currentUser.lastName || '';
    return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase();
  }
}